export default __webpack_public_path__ + "static/media/Income & expense.51a50433.png";